var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4225 34.1783C49.2925 33.6165 49.2175 33.0329 49.2175 32.4329C49.2175 28.136 52.7134 24.6543 57.0239 24.6543C61.3344 24.6543 64.8303 28.1378 64.8303 32.4329C64.8303 36.728 61.3344 40.2115 57.0239 40.2115H44.9766",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3943 55.1641C49.257 55.724 49.1747 56.3058 49.1673 56.9077C49.1143 61.2027 52.5645 64.73 56.8768 64.7829C61.1872 64.8358 64.7271 61.3979 64.7802 57.101C64.8333 52.8059 61.3831 49.2786 57.0708 49.2257L45.0234 49.0762",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2422 2.09766V19.4951C51.5887 18.0415 54.3507 17.1879 57.3177 17.1879C65.7849 17.1879 72.6487 24.0273 72.6487 32.4642C72.6487 35.5939 71.7005 38.5011 70.0807 40.9231H87.8936",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2422 87.9016V70.5042C51.5887 71.9578 54.3507 72.8114 57.3177 72.8114C65.7849 72.8114 72.6487 65.972 72.6487 57.535C72.6487 54.4054 71.7005 51.4982 70.0807 49.0762H87.8936",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5797 34.1783C40.7097 33.6165 40.7847 33.0329 40.7847 32.4329C40.7847 28.136 37.2888 24.6543 32.9783 24.6543C28.666 24.6543 25.1719 28.1378 25.1719 32.4329C25.1719 36.728 28.6678 40.2115 32.9783 40.2115H45.0257",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6053 55.1641C40.7425 55.724 40.8249 56.3058 40.8322 56.9077C40.8853 61.2027 37.4351 64.73 33.1228 64.7829C28.8123 64.8358 25.2724 61.3979 25.2194 57.101C25.1663 52.8059 28.6165 49.2786 32.9288 49.2257L44.9761 49.0762",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7569 2.09766V19.4951C38.4104 18.0415 35.6484 17.1879 32.6814 17.1879C24.2142 17.1879 17.3504 24.0273 17.3504 32.4642C17.3504 35.5939 18.2985 38.5011 19.9184 40.9231H2.10547",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7569 87.9016V70.5042C38.4104 71.9578 35.6484 72.8114 32.6814 72.8114C24.2142 72.8114 17.3504 65.972 17.3504 57.535C17.3504 54.4054 18.2985 51.4982 19.9184 49.0762H2.10547",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJunction);
export default __webpack_public_path__ + "static/media/junction.11c9fd404be934081cc0e01bba00c69f.svg";
export { ForwardRef as ReactComponent };